import { APP_INITIALIZER, NgModule } from '@angular/core';
import { PortalComponent } from './portal.component';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InjectorModule } from '../app/shared/modules/injector.module';
import { PortalRoutingModule } from './portal-routing.module';
import { MaterialModule } from '../app/material.module';
import { NavbarComponent } from './components/navbar/navbar.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SidebarListComponent } from './components/sidebar/sidebar-list/sidebar-list.component';
import { SidebarMobileHeaderComponent } from './components/sidebar/sidebar-mobile-header/sidebar-mobile-header.component';
import { PortalHomeComponent } from './pages/portal-home/portal-home.component';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { DatadogRumService } from 'src/app/shared/services/datadog.service';
import { WINDOW_PROVIDERS } from 'src/app/shared/utils/window.provider';
import { AuthModule, LogLevel } from 'angular-auth-oidc-client';
import { PortalInitializationService } from './config/portal-initialization.service';
import { PortalLoginComponent } from './pages/portal-login/portal-login.component';
import { PortalTokenInterceptor } from './auth/portal-token.interceptor';
import { CredentialsComponent } from './pages/credentials/credentials.component';
import { PortalProfileComponent } from './pages/portal-profile/portal-profile.component';
import { PortalAddressFormatPipe } from './pages/portal-profile/portal-address-format.pipe';
import { PortalProfileNamePipe } from './pages/portal-profile/portal-profile-name.pipe';

@NgModule({
  declarations: [
    PortalComponent,
    NavbarComponent,
    DashboardComponent,
    SidebarListComponent,
    SidebarMobileHeaderComponent,
    PortalHomeComponent,
    PortalLoginComponent,
    CredentialsComponent,
    PortalProfileComponent,
    PortalAddressFormatPipe,
    PortalProfileNamePipe,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    InjectorModule,
    MaterialModule,
    PortalRoutingModule,
    FlexLayoutModule,
    AuthModule.forRoot({
      config: {
        authority:
          window.location.hostname == 'localhost'
            ? 'https://localhost:5430'
            : `https://${window.location.hostname}/idsrv`,
        redirectUrl:
          window.location.hostname == 'localhost'
            ? 'https://localhost:4200/portal/login'
            : `https://${window.location.hostname}/portal/login`,
        postLogoutRedirectUri:
          window.location.hostname == 'localhost'
            ? 'https://localhost:4200/portal'
            : `https://${window.location.hostname}/portal`,
        clientId: window.location.hostname,
        scope: 'openid profile email api offline_access',
        responseType: 'code',
        silentRenew: true,
        useRefreshToken: true,
        renewTimeBeforeTokenExpiresInSeconds: 60,
        logLevel: window.location.hostname == 'localhost' ? LogLevel.Debug : LogLevel.None,
      },
    }),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (appInit: PortalInitializationService, dataDogRum: DatadogRumService) => () =>
        appInit.load().then((appConfig) => {
          if (appConfig?.initialized) {
            dataDogRum.initLineupPortal(appConfig);
          }
        }),
      multi: true,
      deps: [PortalInitializationService, DatadogRumService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PortalTokenInterceptor,
      multi: true,
    },
    WINDOW_PROVIDERS,
  ],
  bootstrap: [PortalComponent],
})
export class PortalModule {}
